(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-simple"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      const slidesEl = root.querySelector('.apple-product__slides');
      const dotsEl = root.querySelector('.apple-product__dots');
      if (slidesEl && dotsEl) {
        const dots = Array.from(dotsEl.querySelectorAll('[data-dot]'));
        slidesEl.addEventListener('scroll', () => {
          const index = Math.round(slidesEl.scrollLeft / slidesEl.offsetWidth);
          dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        }, { passive: true });
      }

      const heroImage = root.querySelector('.apple-product__hero-image');
      const thumbButtons = Array.from(root.querySelectorAll('[data-thumb]'));
      const zoomButton = root.querySelector('[data-gallery-zoom]');
      const imageDialog = document.querySelector('[data-image-dialog]');
      const dialogImage = imageDialog ? imageDialog.querySelector('[data-dialog-image]') : null;
      const imageClose = imageDialog ? imageDialog.querySelector('[data-image-close]') : null;
      const videoButton = root.querySelector('[data-video-open]');
      const videoDialog = document.querySelector('[data-video-dialog]');
      const videoClose = videoDialog ? videoDialog.querySelector('[data-video-close]') : null;
      const videoElement = videoDialog ? videoDialog.querySelector('[data-product-video]') : null;

      thumbButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!heroImage) return;
          heroImage.src = button.dataset.imageSrc || heroImage.src;
          heroImage.alt = button.dataset.imageAlt || heroImage.alt;
          if (zoomButton) {
            zoomButton.dataset.src = button.dataset.zoomSrc || button.dataset.imageSrc || '';
            zoomButton.dataset.alt = button.dataset.imageAlt || '';
          }
          thumbButtons.forEach((thumb) => thumb.classList.remove('is-active'));
          button.classList.add('is-active');
        });
      });

      if (zoomButton && imageDialog && dialogImage) {
        zoomButton.addEventListener('click', () => {
          if (!zoomButton.dataset.src) return;
          dialogImage.src = zoomButton.dataset.src;
          dialogImage.alt = zoomButton.dataset.alt || '';
          imageDialog.showModal();
        });
      }

      if (imageDialog && imageClose) {
        imageClose.addEventListener('click', () => imageDialog.close());
        imageDialog.addEventListener('click', (event) => {
          if (event.target === imageDialog) imageDialog.close();
        });
      }

      if (videoButton && videoDialog) {
        videoButton.addEventListener('click', () => {
          videoDialog.showModal();
          if (videoElement) videoElement.play();
        });
      }

      if (videoDialog && videoClose) {
        videoClose.addEventListener('click', () => {
          videoDialog.close();
          if (videoElement) videoElement.pause();
        });
        videoDialog.addEventListener('click', (event) => {
          if (event.target === videoDialog) {
            videoDialog.close();
            if (videoElement) videoElement.pause();
          }
        });
      }

      const variantBtns = Array.from(root.querySelectorAll('.apple-product__variant-btn'));
      const variantInput = root.querySelector('input[name="id"]');
      const atcBtn = root.querySelector('.apple-product__submit');
      const buyNowBtn = root.querySelector('.apple-product__buy-now');
      const priceEl = root.querySelector('.apple-product__price');
      const compareEl = root.querySelector('.apple-product__compare-price');

      variantBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          variantBtns.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          const vid = btn.dataset.variantId;
          const available = btn.dataset.variantAvailable === 'true';

          if (variantInput) variantInput.value = vid;
          if (priceEl) priceEl.textContent = btn.dataset.variantPrice;
          if (compareEl) {
            compareEl.textContent = btn.dataset.variantCompare || '';
            compareEl.style.display = btn.dataset.variantCompare ? '' : 'none';
          }
          if (atcBtn) {
            atcBtn.disabled = !available;
            atcBtn.textContent = available ? 'Add to cart' : 'Sold out';
          }
          if (buyNowBtn) {
            if (available) {
              buyNowBtn.href = '/cart/' + vid + ':1';
              buyNowBtn.classList.remove('is-disabled');
              buyNowBtn.removeAttribute('aria-disabled');
            } else {
              buyNowBtn.removeAttribute('href');
              buyNowBtn.classList.add('is-disabled');
              buyNowBtn.setAttribute('aria-disabled', 'true');
            }
          }

          document.dispatchEvent(new Event('change'));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
